import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

import { AlertListItem, CreateAlertPayload } from './alert.types';

interface Request {
  id: number;
  data: Partial<CreateAlertPayload>;
}

export const updateAlert = async (
  { id, data }: Request,
  options: ServiceRequestConfig = {},
) => {
  return await pilot.patch<AlertListItem>(
    `/alert/${id}/`,
    { ...data },
    options,
  );
};
